import { parseCreateVideoConfig } from './parseCreateVideoConfig.js';
import { bootCreateVideoPage } from '../createVideoPage.js';

export const startCreateVideoPage = async (config = parseCreateVideoConfig()) => {
  await bootCreateVideoPage(config);
};
